import { Injectable } from "@angular/core";
import { Language } from "../model/language.model";
import { HttpParams } from "@angular/common/http";
import { ApiService, GenericResponse } from "@uranda/commons";

@Injectable({
    providedIn: 'root'
})
export class LanguageService extends ApiService {

    async getLanguages(countryId?: string, regionId?: string, districtId?: string): Promise<Language[]> {
        let queryParameters = new HttpParams();

        if (countryId !== undefined) {
            queryParameters = queryParameters.append('countryId', countryId);
        }

        if (regionId !== undefined) {
            queryParameters = queryParameters.append('regionId', regionId);
        }

        if (districtId !== undefined) {
            queryParameters = queryParameters.append('districtId', districtId);
        }

        const response = await this.get('/v1/languages', queryParameters);
        return response.data;
    }

}